/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Versions_DescriptionInputs */



/**
* | output |
* | --- |
* | "Every save of this app is kept here: the 50 newest, plus every version marked as working." |
*
* @param {Canvas_Versions_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_versions_description = /** @type {((inputs?: Canvas_Versions_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Versions_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Jede Speicherung dieser App wird hier aufbewahrt: die 50 neuesten und jede als funktionierend markierte Version.")
	return /** @type {LocalizedString} */ ("Every save of this app is kept here: the 50 newest, plus every version marked as working.")
});